module.exports = __webpack_public_path__ + "img/avatar3_11zon.94566a1b.webp";